import { Button, Modal } from 'react-bootstrap';

import AppButton from '../buttons/AppButton';
import { useNavigate } from 'react-router-dom';

export function ContractInvalidModal({ show, onHide }) {
  const navigate = useNavigate();

  const handleRedirect = () => {
    onHide();
    navigate('assinatura');
  };

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>⚠️ Acesso restrito</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Seu plano atual não inclui acesso a esta funcionalidade.<br></br>
        Entre em contato com o suporte para alterar seu plano ou obter mais informações.
      </Modal.Body>
      <Modal.Footer>
        <AppButton name='entrar em contato' onClick={handleRedirect} />
      </Modal.Footer>
    </Modal>
  );
}